// RSS COMMERCE — RSS calculator
// Ported from rss-commerce-demo/assets/js/app.js. Scoped per-instance so the
// section can be added more than once in the theme editor without id clashes.
(function () {
  'use strict';

  function clamp(n, min, max, fallback) {
    if (isNaN(n)) return fallback;
    return Math.min(max, Math.max(min, Math.round(n)));
  }

  function fmtB(n) {
    if (Number.isInteger(n)) return n.toLocaleString('en-US') + 'B';
    return n.toFixed(1) + 'B';
  }

  // Business rule discount tiers — do not add tiers beyond this table.
  function discountPct(qty) {
    if (qty >= 1000) return 20;
    if (qty >= 500) return 15;
    if (qty >= 200) return 10;
    if (qty >= 100) return 5;
    return 0;
  }

  function formatMoney(root, dollars) {
    var cents = Math.round(dollars * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && root.dataset.moneyFormat) {
      return window.Shopify.formatMoney(cents, root.dataset.moneyFormat);
    }
    return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: dollars % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }

  function initCalculator(root) {
    var min = parseFloat(root.dataset.min) || 1;
    var max = parseFloat(root.dataset.max) || 2000;
    var defaultQty = clamp(parseFloat(root.dataset.default), min, max, 500);

    var state = { qty: defaultQty };

    var qtyInput = root.querySelector('[data-rss-qty-input]');
    var slider = root.querySelector('[data-rss-qty-slider]');
    var decBtn = root.querySelector('[data-rss-qty-dec]');
    var incBtn = root.querySelector('[data-rss-qty-inc]');
    var presetBtns = root.querySelectorAll('[data-rss-preset]');

    function setText(selector, value) {
      var el = root.querySelector(selector);
      if (el) el.textContent = value;
    }

    function render() {
      var qty = state.qty;
      var pct = discountPct(qty);
      var base = qty;
      var discountAmt = (base * pct) / 100;
      var final = base - discountAmt;
      var effective = final / qty;
      var each = qty / 4;

      setText('[data-rss-total]', fmtB(qty));
      root.querySelectorAll('[data-rss-each]').forEach(function (el) {
        el.textContent = fmtB(each);
      });
      setText('[data-rss-base]', formatMoney(root, base));
      setText('[data-rss-discount-pct]', pct + '%');
      setText('[data-rss-savings]', formatMoney(root, discountAmt));
      setText('[data-rss-final]', formatMoney(root, final));
      setText('[data-rss-effective]', formatMoney(root, effective) + ' / 1B');

      if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = qty;
      if (slider && document.activeElement !== slider) slider.value = qty;

      presetBtns.forEach(function (btn) {
        var v = Number(btn.getAttribute('data-rss-preset'));
        btn.classList.toggle('is-active', v === qty);
      });
    }

    function setQty(n) {
      state.qty = clamp(n, min, max, state.qty);
      render();
    }

    if (decBtn) decBtn.addEventListener('click', function () { setQty(state.qty - 10); });
    if (incBtn) incBtn.addEventListener('click', function () { setQty(state.qty + 10); });
    if (qtyInput) qtyInput.addEventListener('input', function (e) { setQty(parseFloat(e.target.value)); });
    if (slider) slider.addEventListener('input', function (e) { setQty(parseFloat(e.target.value)); });

    presetBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(Number(btn.getAttribute('data-rss-preset')));
      });
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-rss-calculator]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
